module.exports = __webpack_public_path__ + "static/media/moment-row-star-selected.4458d8cc.svg";